module.exports = __webpack_public_path__ + "img/touxiang.e4a2304a.png";